/** Optional detail when connectivity fails (user-facing wording). */
export async function logIceFailureDiag(
  conn: RTCPeerConnection,
  log: (line: string) => void
): Promise<void> {
  try {
    const stats = await conn.getStats();
    let failed = 0;
    let succeeded = 0;
    stats.forEach((report) => {
      if (report.type !== 'candidate-pair') return;
      const p = report as unknown as Record<string, unknown>;
      const state = String(p.state ?? '');
      if (state === 'failed') failed++;
      else if (state === 'succeeded' || p.nominated === true) succeeded++;
    });
    if (failed > 0 && succeeded === 0) {
      log('Could not establish a connection path');
    }
  } catch {
    log('Connectivity check failed');
  }
}
